<template>
  <v-container class="pa-0 text-center py-12" fluid>
    <h1>Page Not Found</h1>
    <p class="subheading">The page you are looking for does not exist.</p>
  </v-container>
</template>

<script>
// @ is an alias to /src
export default {
  name: "404",
};
</script>
